import store from "../store";
import router from "@/router";
import getSliderFilterName from "@/helpers/getSliderFilterName";

const max_filters = store.state.moduleOldCars.startParams;


export default {
    joinFilterName: function (f) {
        for (let k in f) {
            if (f[k].type == "verdtilbod" || f[k].type == "girartegund") {
                f[k].type = "other";
            }
        }
    },
    mobilecheck() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    },
    groupFiltersName: function (f) {
        let res = {};
        for (let k in f) {
            let item = f[k];
            if (typeof res[item.type] == "undefined") {
                res[item.type] = [];
            }
            res[item.type].push(item.name);
        }
        return res;
    },
    setFilter: function (ff, param, id, items) {
        if (typeof ff[param] == "undefined") {
            ff[param] = [];
        }
        var f = ff[param];
        if (f.indexOf(id) >= 0) {
            f.splice(f.indexOf(id), 1);
        } else {
            f.push(id);
        }
    },
    addFilersName: function (f, d) {
        if (!d) {
            return false;
        }

        const lib = store.state.lib;

        let res = [];

        let other = [];
        if (d && d.other && Object.keys(d.other).length < 10) {
            for (let key in d.other) {
                other = other.concat(...d.other[key])
            }
        } else {
            other = d ? d.other : null;
        }

        const labels = {
            argerd: { label: "Árgerð", unit: '' },
            verd: { label: "Verð", unit: 'kr.' },
            ekinn: { label: "Akstur", unit: 'km.' },
            cylinders: { label: "Strokkar", unit: '' },
            affinity: { label: "Drægni", unit: 'km.' },
            towing_capacity: { label: "Dráttargeta", unit: 'kg.' },
            tire_size: { label: "Dekkjastærð", unit: '' },
            rim_size: { label: "Felgustærð", unit: '' },
        }
        for (let k in f) {
            let item = f[k];
            if(getSliderFilterName(item, k)){
                let name = getSliderFilterName(item, k)
                res.push({
                    type: k,
                    id: 0,
                    name: name
                });
                continue;
            }

            if (Object.keys(labels).includes(k)) {
                if (!item[0]) {
                    item[0] = 0;
                }

                let maxPrice = k === "argerd" ? +item[1] : parseInt(item[1]).format();
                if (parseInt(item[1]) == 20 * 1000 * 1000) {
                    maxPrice += "+"
                }

                let name = null;
                name = `${labels[k].label} frá ` + (k === "argerd" ? +item[0] : parseInt(item[0]).format()) + ` ${labels[k].unit} til ` + maxPrice + ` ${labels[k].unit} `;

                res.push({
                    type: k,
                    id: 0,
                    name: name
                });
                continue;
            }
/*
            if (k == "affinity") {
                const min = item[0] ? item[0] : max_filters.affinity.min;
                const max = item[1] ? item[1] : max_filters.affinity.max;

                let name = null;
                if(!item[1]){
                    name = "Drægni frá  " + parseInt(min).format() + " km.";
                }else{
                    name = "Drægni frá  " + parseInt(min).format() + " km. til " + parseInt(max).format() + " km. ";
                }
                res.push({
                    type: k,
                    id: 0,
                    name: name
                });
                continue;
            }*/
/*
            if (k == "engine") {
                let name = getSliderFilterName(item, k);
                res.push({
                    type: k,
                    id: 0,
                    name: name
                });
                continue;
            }


            if (k == "horse_power") {
                let name = getSliderFilterName(item, k);
                res.push({
                    type: k,
                    id: 0,
                    name: name
                });
                continue;
            }
*/
/*
            if (k == "towing_capacity") {
                const min = item[0] ? item[0] : max_filters.towing_capacity.min;
                const max = item[1] ? item[1] : max_filters.towing_capacity.max;
                let name = null;

                if(min == 0){
                    name = "Dráttargeta allt að " + parseInt(max).format() + " kg. ";
                }else{
                    name = "Dráttargeta frá  " + parseInt(min).format() + " kg. til " + parseInt(max).format() + " kg. ";
                }
                res.push({
                    type: k,
                    id: 0,
                    name: name
                });
                continue;
            }

            if (k == "argerd") {
                const minVal = oldCarsStartParams[k].min;
                let name = "Árgerð frá " + (item[0] <= minVal ? '<' : '') + item[0] + " til " + item[1];
                res.push({
                    type: k,
                    id: 0,
                    name: name
                });
                continue;
            }

            if (k == "ekinn") {
                const maxVal = oldCarsStartParams[k].max;
                let name =
                    "Akstur allt að frá " +
                    parseInt(item[0]).format() +
                    " til " +
                    parseInt(item[1]).format() + (parseInt(item[1]) >= maxVal ? '+' : '');
                res.push({
                    type: k,
                    id: 0,
                    name: name
                });
                continue;
            }
*/
            if (k == "k7") {
                continue;
            }

            if (k == "verdtilbod") {
                res.push({
                    type: k,
                    id: false,
                    name: "Tilboðsbílar"
                });
                continue;
            }

            if (k == "notInCountry") {
                res.push({
                    type: k,
                    id: false,
                    name: "Staðsett erlendis"
                });
                continue;
            }

            if (k == "discount") {
                res.push({
                    type: k,
                    id: item,
                    name: "Tilboðsbílar"
                });
                continue;
            }

            if (k == "parking") {
                res.push({
                    type: k,
                    id: false,
                    name: "Á staðnum"
                });
                continue;
            }

            if (k == 'company') {
                for (let com in item) {
                    let el = this.findInArr(store.state.lib.new_cars_companies, item[com], true);
                    res.push({
                        type: k,
                        id: item[com],
                        name: el.name
                    })
                }
                continue;
            }

            if (k == "companies") {
                for (let com in item) {
                    let el = this.findInArr(store.state.lib.old_cars_companies, item[com], true);
                    res.push({
                        type: k,
                        id: item[com],
                        name: el.name
                    })
                }
                continue;
            }

            for (let kk in item) {
                let item2 = item[kk];

                let e = findInArr(d[k], item2, true);

                let name = e.name;

                if (k === 'models_id' && d['brands_model']) {
                    let model = d['brands_model'].find(e => e.id == item2);
                    if (model) {
                        name = model.model_class;
                    }
                }

                if (k === 'models_id' && d['new_cars_models']) {
                    let model = d['new_cars_models'].find(e => e.model_id == item2);
                    if (model) {
                        name = model.model_class;
                    }
                }

                if (k == "brands_model" && !name && e.model_class) {
                    name = e.model_class;
                }

                if (k == "brand_model") {
                    let brand_id = item2;
                    let e = findInArr(lib.old_cars_models, brand_id, true);
                    name = e.name;
                }

                if (k == "vt") {
                    let e = findInArr(d.vehicle_type, item2, true);
                    name = e.name;
                }
/*
                if(k == 'aukahlutir'){
                    let e = findInArr(lib.aukahlutir, item2, true);
                    name = e.name;
                }
*/
                if (k == "other") {
                    let e = findInArr(other, item2, true);
                    name = e.name;
                }

                if (k == 'brands') {
                    if (parseInt(item2) > 0) {
                        let e = findInArr(lib.old_cars_brands, item2, true);
                        name = e.name;
                    }
                }

                if (k == "girartegund" || k == 'transmision') {
                    name = lib.girartegund ? lib.girartegund[item2].name : null;
                }

                if (k == 'year') {
                    name = item2;
                }

                if (k == 'category') {
                    for (let key4 in d.categories) {
                        if (key4 == item2) {
                            name = d.categories[key4];
                        }
                    }
                }

                if(['seats_number','aukahlutir'].includes(k)){
                    let findItem = lib[k].find(e => e.id == item2);
                    if(findItem){
                        name = findItem.name;
                    }
                }

                if (k == 'cat') {
                    let res = lib && lib.cat_new_cars && lib.cat_new_cars.find(e => e.id == item2);
                    if (res) {
                        name = res.name;
                    }
                }

                res.push({
                    type: k,
                    id: item2,
                    name: name
                });
            }
        }

        return res;
    },
    cleanFilters: function (f) {
        let res = {};

        for (let k in f) {
            if(store.state.excludeFilterParams.includes(k)){
                continue;
            }
            let item = f[k];


            if(router.currentRoute.name === 'DealersCars'){
                const newCarsStartParams = store.state.newCars.startParams;
                if(newCarsStartParams[k]){
                    const curItem = newCarsStartParams[k];
                    if (item[0] == curItem.min && item[1] == curItem.max) {
                        continue;
                    }
                }
            }

            if(['argerd','ekinn','verd','affinity','towing_capacity','cylinders','rim_size','tire_size'].includes(k)){
                if (item[0] == max_filters[k].min && item[1] == max_filters[k].max) {
                    continue;
                }
            }

            if (k == "verdtilbod" && item) {
                res[k] = item;
                continue;
            }

            if (k == "notInCountry" && item) {
                if(Array.isArray(item) && item.length == 1){
                    res[k] =  item[0]==true?true:false;
                }else if(Array.isArray(item) && item.length == 0){
                    res[k] = false;
                }else {
                    res[k] = item;
                }
                continue;
            }

            if (k == "k7" && item) {
                res[k] = item;
                continue;
            }

            if (k == "parking" && item) {
                if(Array.isArray(item) && item.length == 1){
                    res[k] =  item[0]==true?true:false;
                }else if(Array.isArray(item) && item.length == 0){
                    res[k] = false;
                }else {
                    res[k] = item;
                }
                continue;
            }

            if (item.length > 0) {
                if (["argerd", "ekinn", "verd", "affinity", "towing_capacity",'cylinders','rim_size','tire_size'].indexOf(k) >= 0) {
                    console.log('item',item);
                    res[k] = item;
                } else {
                    res[k] = item.slice(0).sort();
                }
            }
        }

        console.log("res",res);
        return res;
    },
    getParams: function (d) {
        if (window.location.search.slice(1)) {
            var p = window.location.search.slice(1);

            p = p.replace("=%3D", "");
            p = p.replace("e30=", "");
            p = p.replace(/\//g, "%2F");
            if (p) {
                let f = JSON.parse(window.atob(p));

                for (var k in f) {
                    let item = f[k];
                    d[k] = item;
                }

            } else {
                this.resetFilter();
            }
        }
    },
    resetFilter(filters) {
        if (filters) {
            for (let k in filters) {
                if (k != "argerd" && k != "verd" && k != "ekinn") {
                    if (filters[k].length > 0) {
                        filters[k] = [];
                        // console.log(k);
                    }
                }
            }

            filters.verd = [max_filters.verd.mi, max_filters.verd.ma];
            filters.argerd = [max_filters.argerd.mi, max_filters.argerd.ma];
            filters.ekinn = [max_filters.ekinn.mi, max_filters.ekinn.ma];
            filters.verdtilbod = false;
            filters.parking = false;
            filters.discount = false;
        }
    },
    unselectFilter(type, id, f) {
        console.log(">>>>>>>>>>.",id);
        let filter = f || window.filters;
        // console.log('filter', [filter, type, filter[type]]);
        if (type == "verdtilbod" || type == "parking") {
            filter[type] = id;
        }
        if (["argerd", "ekinn", "verd"].indexOf(type) >= 0) {
            if (window.location.pathname == "/bilaumbod" || '/kjarabilar') {
                filter[type] = [];
                filter[type] = [window.price_f.mi, window.price_f.ma];
                // console.log("THIS",window.price_f);
            } else {
                filter[type] = [max_filters[type].mi, max_filters[type].ma];
            }
        } else {
            filter[type].splice(filter[type].indexOf(id), 1);
        }
    },
    findInArr: function (arr, id, e, key, filterName) {
        key = key || "id";
        for (var k in arr) {
            var item = arr[k];

            if (filterName && item.filter_name !== filterName) continue

            if (item[key] == id) {
                if (e) {
                    return item;
                }
                return k;
            }
        }
        return false;
    },
    setUrlParams: function (params) {
        let f = params;
        let d = window.btoa(JSON.stringify(f));
        let url = "?" + d;
        return url;
        // this.$router.push(url);
    }
};


//from f.js

function findInArr(arr, id, e, key) {
    key = key || 'id';
    for (var k in arr) {
        var item = arr[k];
        if (item[key] == id) {
            if (e) {
                return item;
            }
            return k;
        }
    }
    return false;
}
